// extracted by mini-css-extract-plugin
export var button = "_fi-0";
export var donut = "_fi-1";
export var donutFill = "_fi-3";
export var donutTrack = "_fi-2";